import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { fetchCurrentUser } from '../../store/slices/authSlice';
import { Spinner } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

const PrivateRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isAuthenticated, loading, token, user } = useAppSelector((state) => state.auth);

  // Проверяем токен при монтировании компонента
  useEffect(() => {
    // Если есть токен, но нет данных пользователя, загружаем их
    if (token && (!user || !user.username)) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch, token, user]);

  // Показываем загрузку во время проверки токена
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Проверка авторизации...</p>
        </div>
      </div>
    );
  }

  // Если не авторизован, перенаправляем на страницу входа
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Если авторизован, показываем защищенный контент
  return <Outlet />;
};

export default PrivateRoute;
